import { STATE_LABELS } from "./esriQualApi";

const FLOW = ["CONFIGURATION_INCOMPLETE", "CONFIGURATION_READY", "AUTHORIZED_PROBE", "QUALIFICATION_GO", "QUALIFICATION_RUNNING", "QUALIFICATION_COMPLETED"];

export function QualStateBar({ state }) {
  const failed = state === "QUALIFICATION_FAILED";
  const idx = failed ? FLOW.indexOf("CONFIGURATION_READY") : FLOW.indexOf(state);
  return (
    <div data-testid="esri-qual-state" data-state={state} className="space-y-2">
      <div className="flex flex-wrap gap-1">
        {FLOW.map((s, i) => (
          <span key={s} data-testid={`esri-qual-step-${s}`}
            className={`font-mono text-[9px] uppercase tracking-wider px-2 py-1 rounded-sm border transition-colors ${i < idx ? "border-[#22C55E]/40 text-[#22C55E]" : i === idx ? "border-[#F59E0B] bg-[#F59E0B]/15 text-[#F59E0B]" : "border-white/10 text-[#525252]"}`}>
            {i + 1}. {STATE_LABELS[s]}
          </span>
        ))}
        {failed && <span data-testid="esri-qual-step-FAILED" className="font-mono text-[9px] uppercase tracking-wider px-2 py-1 rounded-sm border border-[#EF4444] bg-[#EF4444]/15 text-[#EF4444]">{STATE_LABELS.QUALIFICATION_FAILED}</span>}
      </div>
      <div className="font-mono text-xs">ÉTAT : <span data-testid="esri-qual-state-label" className={failed ? "text-[#EF4444]" : "text-[#F59E0B]"}>{state}</span></div>
    </div>
  );
}
